import Panel from '@/shared/components/Panel';
import ReactDataTableComponent from '@/shared/components/ReactDataTableComponent';
import { colorText } from '@/utils/palette';
import dayjs from 'dayjs';
import { useState } from 'react';
import styled from 'styled-components';
import LogDetailModal from './GpuOneLogDetailModal';

const GpuOneLogsTable = ({ logs = [] }) => {
	const [selectedLog, setSelectedLog] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleLogClick = log => {
		setSelectedLog(log);
		setIsModalOpen(true);
	};

	const handleCloseModal = () => {
		setIsModalOpen(false);
		setSelectedLog(null);
	};

	const columns = [
		{
			name: 'ID',
			selector: row => row.id,
			sortable: true,
		},
		{
			name: 'Log ID',
			selector: row => row.log_id,
			sortable: true,
		},
		{
			name: 'Machine ID',
			selector: row => row.log_machine_id,
			sortable: true,
		},
		{
			name: 'Message',
			selector: row => row.log_message,
			sortable: true,
			grow: 3,
			cell: row => (
				<ClickableMessageCell onClick={() => handleLogClick(row)}>
					<MessageText>{row.log_message}</MessageText>
					<ClickHint>Click to view full log</ClickHint>
				</ClickableMessageCell>
			),
		},
		{
			name: 'Log Name',
			selector: row => row.log_name,
			sortable: true,
			width: '100px',
		},
		{
			name: 'Serial Number',
			selector: row => row.serial_number,
			sortable: true,
		},
		{
			name: 'Log Created',
			selector: row => row.log_created,
			sortable: true,
			cell: row => (
				<TimeCell>
					{dayjs(row.log_created).format('MM/DD/YYYY hh:mm A')}
				</TimeCell>
			),
		},
		{
			name: 'Log Updated',
			selector: row => row.log_updated,
			sortable: true,
			cell: row => (
				<TimeCell>
					{dayjs(row.log_updated).format('MM/DD/YYYY hh:mm A')}
				</TimeCell>
			),
		},
		{
			name: 'Last Updated',
			selector: row => row.last_updated,
			sortable: true,
			cell: row => (
				<TimeCell>
					{dayjs(row.last_updated).format('MM/DD/YYYY hh:mm A')}
				</TimeCell>
			),
		},
	];

	return (
		<>
			<Panel
				title="System Logs"
				lg={12}
				xl={12}
				md={12}
				sm={12}
				subhead="Select the log message to view the full log"
			>
				<LogsContainer>
					<ReactDataTableComponent
						columns={columns}
						data={logs}
						pagination={true}
						paginationPerPage={10}
						paginationRowsPerPageOptions={[10, 20, 30, 50]}
						highlightOnHover={true}
						responsive={true}
						progressPending={false}
						onRowClicked={handleLogClick}
					/>
				</LogsContainer>
			</Panel>

			<LogDetailModal
				isOpen={isModalOpen}
				onClose={handleCloseModal}
				log={selectedLog}
			/>
		</>
	);
};

export default GpuOneLogsTable;

const LogsContainer = styled.div`
	margin-top: 20px;
`;

const ClickableMessageCell = styled.div`
	max-width: 300px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	cursor: pointer;
	padding: 8px;
	border-radius: 4px;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: rgba(0, 0, 0, 0.05);
	}
`;

const MessageText = styled.span`
	color: ${colorText};
	font-size: 0.9rem;
	display: block;
`;

const ClickHint = styled.span`
	color: #6c757d;
	font-size: 0.75rem;
	font-style: italic;
	display: block;
	margin-top: 2px;
`;

const TimeCell = styled.div`
	font-size: 0.85rem;
	color: ${colorText};
	white-space: nowrap;
`;
